import {connect, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import React, {useCallback, useMemo, useRef, useState} from "react";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormInput,
    CInputGroup,
    CInputGroupText, CModal, CModalBody,
    CModalHeader, CModalTitle,
    CRow
} from "@coreui/react";
import numeral from "numeral";
import {AgGridReact} from "ag-grid-react";
import * as api from "../../../api/api";
import {Loading} from "../../../components/common";
import StoreListWhere from "../where/StoreListWhere";
import StoreDetail from "../store/StoreDetail";
import ProductDetail from "./ProductDetail";
import StoreCornerListWhere from "../where/StoreCornerListWhere";

const ProductSearch = (props) => {
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: '100%', height: '100%'}), []);
    const gridStyle = useMemo(() => ({height: 500, width: '100%'}), []);

    const {user} = useSelector((props) => props.account);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState({
        visible: false,
        message: ""
    });
    const [searchForm, setSearchForm] = useState({
        restProductCd: "",
        productNm: "",
        barcode: ""
    });
    const [modalVisible, setModalVisible] = useState(false);
    const [selectProduct, setSelectProduct] = useState({});

    const currencyFormatter = (params) => {
        return numeral(params.value).format('0,0');
    };

    const [columnDefs] = useState([
        {field: 'seq', headerName: 'No', width: 80},
        {field: 'restProductCd', headerName: '상품코드', width: 140},
        {field: 'productNm', headerName: '상품명'},
        {field: 'barcode', headerName: '바코드', width: 200},
        {field: 'supPrice', headerName: '원가', valueFormatter: currencyFormatter},
        {field: 'price', headerName: '판매단가', valueFormatter: currencyFormatter},
        {field: 'productDiv', headerName: '상품구분', width: 100},
        {field: 'bagYn', headerName: '봉투사용여부'},
        {field: 'bagPrice', headerName: '봉투금액', width: 100}
    ])

    const search = async () => {
        const {cmpCd, brandCd, storeCd} = props.selected;
        if (brandCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 휴게소는 반드시 선택하셔야 합니다."
            })
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            restProductCd: searchForm.restProductCd,
            productNm: searchForm.productNm,
            barcode: searchForm.barcode
        };

        setLoading(true);
        try {
            const {data: result} = await api.getProductList(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setRowData(responseBody);
            } else {

            }
        } catch (e) {
            console.error(e.message);
        } finally {
            setLoading(false);
        }
    };

    const onRowSelected = useCallback((event) => {
        setSelectProduct(event.node.data);
        setModalVisible(true);
    }, []);

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
    };

    return (
        <div style={containerStyle}>
            {loading ? <Loading/> : null}
            {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
            <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                <h5>상품조회</h5>
                <CButton color="dark" onClick={search}>조회</CButton>
            </div>
            <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
            <CForm className={"row g-1"}>
                <CCol md={3}>
                    <CInputGroup className={"mb-1"}>
                        <CInputGroupText style={{width: 100}}>상품코드</CInputGroupText>
                        <CFormInput id="restProductCd"
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            restProductCd: e.target.value
                                        }));
                                    }}
                        />
                    </CInputGroup>
                </CCol>
                <CCol md={3}>
                    <CInputGroup className={"mb-1"}>
                        <CInputGroupText style={{width: 100}}>상품명</CInputGroupText>
                        <CFormInput id="productNm"
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            productNm: e.target.value
                                        }));
                                    }}
                        />
                    </CInputGroup>
                </CCol>
                <CCol md={3}>
                    <CInputGroup className={"mb-1"}>
                        <CInputGroupText style={{width: 100}}>바코드</CInputGroupText>
                        <CFormInput id="barcode"
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            barcode: e.target.value
                                        }));
                                    }}/>
                    </CInputGroup>
                </CCol>

            </CForm>
            <div style={{height: 10}}/>
            <div className="ag-theme-alpine" style={gridStyle}>
                <AgGridReact
                    rowSelection={'single'}
                    pagination={true}
                    suppressDragLeaveHidesColumns={true}
                    onRowDoubleClicked={onRowSelected}
                    rowData={rowData}
                    columnDefs={columnDefs}>
                </AgGridReact>
            </div>
            <CModal size={"xl"} backdrop={"static"} alignment={"center"} visible={modalVisible}
                    onClose={() => setModalVisible(false)}>
                <CModalHeader>
                    <CModalTitle>상품정보</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <ProductDetail data={selectProduct} openType={"R"}/>
                </CModalBody>
            </CModal>
        </div>
    )
}

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductSearch);
